'use client';

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { IVideoGeneration } from '@/features/studio-videos/types/composition';
import { IProject, StudioVideo } from '@/features/ai-video-creator/stores/studioVideoStore';

type EditorStore = {
  generation: IVideoGeneration | null;
  studioVideo: StudioVideo | null;
  project: IProject | null;
  setEditorData: (data: {
    generation: IVideoGeneration | null;
    studioVideo: StudioVideo | null;
    project?: IProject | null;
  }) => void;
  setProject: (project: IProject | null) => void;
  reset: () => void;
};

export const useEditorStore = create<EditorStore>()(
  persist(
    (set) => ({
      generation: null,
      studioVideo: null,
      project: null,
      setEditorData: (data) => {
        const newProject = data.generation
          ? {
              generation: data.generation,
              assets: data.project?.assets || {},
            }
          : null;

        set({
          generation: data.generation,
          studioVideo: data.studioVideo,
          project: data.project || newProject,
        });
      },
      setProject: (project) => set({ project }),
      reset: () => set({ generation: null, studioVideo: null, project: null }),
    }),
    {
      name: 'editor-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
